import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=c37c159e&scoped=true&"
import script from "./UsersPage.vue?vue&type=script&lang=js&"
export * from "./UsersPage.vue?vue&type=script&lang=js&"
import style0 from "./UsersPage.vue?vue&type=style&index=0&id=c37c159e&lang=scss&scoped=true&"
import style1 from "./UsersPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37c159e",
  null
  
)

export default component.exports